module.exports = __webpack_public_path__ + "static/media/md-text.73428a44.svg";